import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import {
  DashboardFinding,
  DashboardOverview,
  dashboardOverviewMock,
  DashboardProductFamily,
} from './dashboard.mock';
import { ViewService } from 'api';

@Injectable({
  providedIn: 'root',
})
export class DashboardOverviewService {
  private readonly viewService = inject(ViewService);

  public getOverview(): Observable<DashboardOverview> {
    return forkJoin({
      pagedComponentRevisions: this.viewService.getRecentlyUsedComponentRevisions(0, 5),
      findings: this.viewService.getMostSevereFindings(0, 5),
      dashboardMetrics: this.viewService.getDashboardMetrics(),
    }).pipe(
      map(({ pagedComponentRevisions, findings, dashboardMetrics }) => {
        return {
          ...dashboardOverviewMock,
          metrics: [
            {
              ...dashboardOverviewMock.metrics[0],
              value: dashboardMetrics.openFindingsValue,
              deltaText: dashboardMetrics.openFindingsDeltaValue,
            },
            {
              ...dashboardOverviewMock.metrics[1],
              value: dashboardMetrics.craRelevantProductRevisionsValue,
              deltaText: dashboardMetrics.craRelevantProductRevisionsDeltaValue,
            },
          ],
          recentlyUsedRevisions: pagedComponentRevisions.items,
          topFindings: findings.items,
        };
      }),
    );
  }
}

export type { DashboardFinding, DashboardOverview, DashboardProductFamily };
